// extracted by mini-css-extract-plugin
export default {"apps-suggestions-title":"_1lo679f","appsSuggestionsTitle":"_1lo679f","title-text":"_1k29v8m","titleText":"_1k29v8m"};